import React from 'react';
import { DoorOpen, Radio, Loader2 } from 'lucide-react';
import { RoomDeviceBinding } from '../../hooks/useRoomDeviceBinding';

interface Props {
  binding: RoomDeviceBinding;
}

// Shared room bind/release card — same UI in Cast Setup (before), the Run
// Console (during) and Results (after), since a room only needs binding
// once and stays bound for the life of the session either way.
const RoomBindingCard: React.FC<Props> = ({ binding }) => {
  const { roomId, roomName, roomDevices, rooms, selectedRoomId, setSelectedRoomId, bindingRoom, bindRoom, releaseBoundRoom } = binding;

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-2xl p-6 flex flex-col gap-4">
      <h2 className="text-sm font-bold text-navy flex items-center gap-2"><DoorOpen size={16} className="text-primary" /> Room</h2>
      {roomId ? (
        <div className="flex items-center justify-between">
          <p className="text-sm text-slate-600">Bound to <span className="font-semibold text-navy">{roomName}</span> — {roomDevices.length} device(s) available.</p>
          <button
            onClick={releaseBoundRoom}
            disabled={bindingRoom}
            className="flex items-center gap-2 rounded-xl h-9 px-4 border border-slate-200 text-slate-600 text-xs font-bold hover:bg-slate-50 disabled:opacity-40"
          >
            Release room
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <select
            value={selectedRoomId}
            onChange={e => setSelectedRoomId(e.target.value)}
            className="flex-1 rounded-xl border border-slate-200 px-3 py-2.5 text-sm text-navy"
          >
            <option value="">Select a room…</option>
            {rooms.map(r => (
              <option key={r.roomId} value={r.roomId} disabled={!r.available}>
                {r.name}{!r.available ? ' (in use)' : ''}
              </option>
            ))}
          </select>
          <button
            onClick={bindRoom}
            disabled={bindingRoom || !selectedRoomId}
            className="flex items-center gap-2 rounded-xl h-10 px-5 bg-white border border-slate-200 text-slate-600 text-sm font-bold hover:bg-slate-50 disabled:opacity-40 shadow-sm"
          >
            {bindingRoom ? <Loader2 size={16} className="animate-spin" /> : <Radio size={16} />}
            Bind room
          </button>
        </div>
      )}
    </div>
  );
};

export default RoomBindingCard;
